import {Locale} from "./locale";
import {Process} from "./process";

export class ProcessTemplate {
    template: string;
    translations: any;
    locales: Locale[];
    localeCodeDefault = 'en';
    process: Process;
}
